import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

import {
  REFERRAL_HEADER,
  REFERRAL_LIST_ITEMS,
  REFERRAL_SUBHEADER,
  REPRESENTATION_HEADER,
  REPRESENTATION_LIST_ITEMS,
  REPRESENTATION_SUBHEADER,
} from '../../../../components/sellerFlow/strings';
import { isAgent } from '../../../../lib/flow/pageHelpers';

export const isEnabled = ({ answers, inputContext: { channel }, featureFlags }: FlowContext) => {
  const isInAgentReferralByInvitationPilot = featureFlags.isInAgentReferralByInvitationPilot;
  const isAgentAndHomeowner =
    (answers['seller.relation_to_owner'] === 'Agent' &&
      answers['agent.relation_to_seller'] === 'self') ||
    answers['seller.relation_to_owner'] === 'AgentAndOwner';

  return !!(
    isInAgentReferralByInvitationPilot &&
    isAgent(answers, channel) &&
    !isAgentAndHomeowner
  );
};

const agentEducationPage: FlowPage = {
  slug: () => 'agent-education',
  nextText: () => 'Next',
  isEnabled,
  autoAdvance: () => false,
  title: () => 'Great! There are two ways agents can work with us.',
  subtitle: () =>
    'You can decide what makes the most sense for you and the homeowner after you receive a' +
    ' estimated offer from Opendoor.',
  questions: ({ inputContext: { market } }): FlowQuestion[] => [
    {
      key: 'seller.referral_agent_education',
      type: 'element',
      component: 'bullet_list',
      props: {
        faqs: [
          {
            title: REFERRAL_HEADER,
            subtitle: REFERRAL_SUBHEADER(market),
            children: REFERRAL_LIST_ITEMS,
          },
        ],
      },
    },
    {
      key: 'seller.representation_agent_education',
      type: 'element',
      component: 'bullet_list',
      props: {
        faqs: [
          {
            title: REPRESENTATION_HEADER,
            subtitle: REPRESENTATION_SUBHEADER(market),
            children: REPRESENTATION_LIST_ITEMS,
          },
        ],
      },
    },
  ],
};

export default agentEducationPage;
